import { client } from './client';

export const getAPIToken = (requestConfig = {}) =>
  client('initiate', {
    ...requestConfig,
    method: 'GET'
  });
